import { createRouter, createWebHashHistory } from 'vue-router'  // 修改为createWebHashHistory
import Index from '../index.vue'
import Privacy from '../privacy.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  }
]

const router = createRouter({
  history: createWebHashHistory(),  // 使用hash模式
  routes
})

export default router